import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll when the route changes so detail pages open at the top
 * (e.g. company details → contact from the links table).
 */
function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search]);

  return null;
}

export default ScrollToTop;
